import { companyInitials, companyTone } from "@/lib/jobVisuals";

/**
 * The employer's mark: their uploaded logo on a white card, or a monogram tile
 * in a stable brand tone when no logo has been supplied.
 */
export default function EmployerLogo({ job = {}, size = "card" }) {
  const box = size === "hero"
    ? "h-16 w-16 sm:h-20 sm:w-20 rounded-[16px] sm:rounded-[20px]"
    : "h-11 w-11 rounded-[12px]";
  const logo = job.company_logo;

  return (
    <span className={`grid shrink-0 place-items-center overflow-hidden border border-white/40 bg-white shadow-[0_6px_18px_rgba(17,17,17,0.18)] ${box}`}>
      {logo ? (
        <img src={logo} alt={`${job.company || "Employer"} logo`} loading="lazy" className="h-full w-full object-contain p-1.5" />
      ) : (
        <span className={`grid h-full w-full place-items-center text-center font-black uppercase leading-none tracking-[-0.03em] text-white ${companyTone(job.company)} ${size === "hero" ? "text-[22px]" : "text-[13px]"}`}>
          {companyInitials(job.company)}
        </span>
      )}
    </span>
  );
}

/** A quiet inline mark, for places where the logo should read as a credit line. */
export function EmployerLogoInline({ job = {} }) {
  const logo = job.company_logo;
  return (
    <span className="grid h-8 w-8 shrink-0 place-items-center overflow-hidden rounded-[9px] border border-black/[0.08] bg-white">
      {logo ? (
        <img src={logo} alt="" loading="lazy" className="h-full w-full object-contain p-1" />
      ) : (
        <span className={`grid h-full w-full place-items-center text-[10px] font-black text-white ${companyTone(job.company)}`}>{companyInitials(job.company)}</span>
      )}
    </span>
  );
}